import {
  REACT_ACCESSLEVELS_LIST,
  REACT_ATLAS_INTEGRATION,
  REACT_DAY_LIGHT_TIME,
  REACT_DELIVERY_REPORT,
  REACT_DEVICE_COMMANDS,
  REACT_INTEGRATION,
  REACT_OPERATION_LOGS,
  REACT_PRE_REGISTRATION_LIST,
  REACT_PRE_REGISTRATION_REPORT_LIST,
  REACT_SAFETY_INSTRUCTIONS,
  REACT_SELF_REGISTRATION_LIST,
  REACT_SMS_TEMPLATE,
  REACT_TIME_SLOTS,
  REACT_URL_ADDITIONAL_SETTINGS,
  REACT_URL_ADDRESSTYPE,
  REACT_URL_APPROVAL,
  REACT_URL_BLACKLISTTYPE,
  REACT_URL_BLACKLISTVISITORS,
  REACT_URL_BLOCKED_VISITORS,
  REACT_URL_CARDTEMPLATE,
  REACT_URL_CHECKINOUTDEVICES,
  REACT_URL_CHECKLIST,
  REACT_URL_CHECKLISTTEMPLATE_USA,
  REACT_URL_DAILYREPORT,
  REACT_URL_DASHBOARD,
  REACT_URL_DEVICELIST,
  REACT_URL_EMERGENCYMESSAGE,
  REACT_URL_EMPLOYEE,
  REACT_URL_INVITATIONREPORT,
  REACT_URL_INVITATIONS,
  REACT_URL_NDA,
  REACT_URL_PERSON,
  REACT_URL_PURPOSETYPE,
  REACT_URL_PURPOSETYPE_USA,
  REACT_URL_REGISTRATIONS,
  REACT_URL_RESTRICTTYPE,
  REACT_URL_ROLE,
  REACT_URL_SELFREGISTRATIONREPORT,
  REACT_URL_SITE,
  REACT_URL_SITETYPE,
  REACT_URL_USER_LIST,
  REACT_URL_USERROLE,
  REACT_URL_VISITINVITE,
  REACT_URL_VISITORTYPE,
  REACT_URL_WALKINREGISTRATIONREPORT,
  REACT_URL_WALKINVISIT,
  REACT_URL_WATCHLIST,
  REACT_URL_ZONE,
} from "../../actions/EndPoints";
import { ReactComponent as Dashboard_Icon } from "../../assets/images/dashboard-icons/dashboard_icon.svg";
import vis_Organization_Icon from "../../assets/images/dashboard-icons/OrganizationGray";
import vis_Device_Icon from "../../assets/images/dashboard-icons/SettingsGray";
import vis_SiteManagement from "../../assets/images/dashboard-icons/Sitemanagementgray2";
import vis_visitor_icon from "../../assets/images/dashboard-icons/VisitorGray";
import vis_Dashboard_Icon from "../../assets/USA_Images/navitem_images/Dashboard";
import DashboardHover from "../../assets/USA_Images/navitem_images/DashBoardHover";
import DeviceManagement from "../../assets/USA_Images/navitem_images/DeviceMangement";
import DeviceManagementHover from "../../assets/USA_Images/navitem_images/DeviceMangeMentHover";
import EmergencyMessageImg from "../../assets/USA_Images/navitem_images/EmergencyMessageImg";
import EmergencyMessageImgHover from "../../assets/USA_Images/navitem_images/EmergencyMesseageHover";
import OrganizationHover from "../../assets/USA_Images/navitem_images/OrganizationHover";
import Organization_Icon from "../../assets/USA_Images/navitem_images/OrganizationWhite";
import ReportIconHover from "../../assets/USA_Images/navitem_images/ReportHover";
import ReportIcon from "../../assets/USA_Images/navitem_images/ReportIcon";
import settingHover from "../../assets/USA_Images/navitem_images/SettingsHoverIcon";
import Device_Icon from "../../assets/USA_Images/navitem_images/settingWhite";
import SiteManagementHover from "../../assets/USA_Images/navitem_images/SiteManagementHover";
import SiteManagement from "../../assets/USA_Images/navitem_images/SiteManagementWhite";
import VisitorWhiteHover from "../../assets/USA_Images/navitem_images/VisitorHover";
import visitor_icon from "../../assets/USA_Images/navitem_images/VisitorWhite";
import BrowserLanguage from "../../components/Util/BrowserLanguage";

let language = BrowserLanguage.getDefaultLanguage();
const dataEn = [
  {
    id: "0",
    name: "Dashboard",
    link: `${REACT_URL_DASHBOARD}`,
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? vis_Dashboard_Icon
        : Dashboard_Icon,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? DashboardHover
        : Dashboard_Icon,
  },
  {
    id: "1",
    name: "Visitors",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? visitor_icon
        : vis_visitor_icon,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? VisitorWhiteHover
        : vis_visitor_icon,
    items: [
      {
        id: "2",
        name: "Invitations",
        link: `${REACT_URL_VISITINVITE}`,
      },
      {
        id: "3",
        name:
          process.env.REACT_APP_ENVIRONMENT === "USA"
            ? "Walk-In Registrations"
            : "Registrations",
        link: `${REACT_URL_WALKINVISIT}`,
      },
      {
        id: "35",
        name: "Self Registrations",
        link: `${REACT_SELF_REGISTRATION_LIST}`,
      },
      {
        id: "36",
        name: "Pre Registrations",
        link: `${REACT_PRE_REGISTRATION_LIST}`,
      },
      {
        id: "4",
        name: "Approvals",
        link: `${REACT_URL_APPROVAL}`,
      },
      {
        id: "5",
        name: "Blocklists",
        link: `${REACT_URL_BLACKLISTVISITORS}`,
      },
    ],
  },
  {
    id: "6",
    name: "Employees",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? Organization_Icon
        : vis_Organization_Icon,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? OrganizationHover
        : vis_Organization_Icon,
    items: [
      {
        id: "7",
        name: "Persons",
        link: `${REACT_URL_EMPLOYEE}`,
      },
      {
        id: "8",
        name: "Roles",
        link: `${REACT_URL_USERROLE}`,
      },
    ],
  },
  {
    id: "10",
    name: "Sites",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? SiteManagement
        : vis_SiteManagement,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? SiteManagementHover
        : vis_SiteManagement,

    items: [
      {
        id: "11",
        name: "Address Types",
        link: `${REACT_URL_ADDRESSTYPE}`,
      },
      {
        id: "12",
        name: "Site Types",
        link: `${REACT_URL_SITETYPE}`,
      },
      {
        id: "13",
        name: "All Sites",
        link: `${REACT_URL_SITE}`,
      },
      {
        id: "14",
        name: "DST",
        link: `${REACT_DAY_LIGHT_TIME}`,
      },
      {
        id: "15",
        name: "Zone",
        link: `${REACT_URL_ZONE}`,
      },
      {
        id: "16",
        name: "Time Slots",
        link: `${REACT_TIME_SLOTS}`,
      },
      {
        id: "17",
        name: "Access Levels",
        link: `${REACT_ACCESSLEVELS_LIST}`,
      },
    ],
  },
  {
    id: "17",
    name: "Devices",
    Icon: DeviceManagement,
    HoverIcon: DeviceManagementHover,
    items: [
      {
        id: "18",
        name: "Devices",
        link: `${REACT_URL_DEVICELIST}`,
      },
    ],
  },

  {
    id: "34",
    name: "Emergency",
    Icon: EmergencyMessageImg,
    HoverIcon: EmergencyMessageImgHover,
    items: [
      {
        id: "01",
        name: "Alerts",
        link: `${REACT_URL_EMERGENCYMESSAGE}`,
      },
    ],
  },

  {
    id: "19",
    name: "Reports",
    Icon: ReportIcon,
    HoverIcon: ReportIconHover,
    items: [
      {
        id: "20",
        name: "Daily Reports",
        link: `${REACT_URL_DAILYREPORT}`,
      },
      {
        id: "21",
        name: "Invitations",
        link: `${REACT_URL_INVITATIONREPORT}`,
      },
      {
        id: "22",
        name: "Walk-In Registrations",
        link: `${REACT_URL_WALKINREGISTRATIONREPORT}`,
      },
      {
        id: "23",
        name: "Self Registrations",
        link: `${REACT_URL_SELFREGISTRATIONREPORT}`,
      },
      {
        id: "24",
        name: "Pre Registrations",
        link: `${REACT_PRE_REGISTRATION_REPORT_LIST}`,
      },
      {
        id: "54",
        name: "Delivery Reports",
        link: `${REACT_DELIVERY_REPORT}`,
      },
      {
        id: "55",
        name: "Device Commands",
        link: `${REACT_DEVICE_COMMANDS}`,
      },
      {
        id: "56",
        name: "Operation Logs",
        link: `${REACT_OPERATION_LOGS}`,
      },
    ],
  },

  {
    id: "24",
    name: "Settings",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? Device_Icon
        : vis_Device_Icon,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? settingHover
        : vis_Device_Icon,
    items: [
      {
        id: "25",
        name: "Visitor Types",
        link: `${REACT_URL_VISITORTYPE}`,
      },
      {
        id: "26",
        name: "Purpose Types",
        link: `${REACT_URL_PURPOSETYPE_USA}`,
      },

      {
        id: "27",
        name: "Blocklist Types",
        link: `${REACT_URL_BLACKLISTTYPE}`,
      },

      {
        id: "28",
        name: "Checklists",
        link: `${REACT_URL_CHECKLISTTEMPLATE_USA}`,
      },

      {
        id: "29",
        name: "Watchlists",
        link: `${REACT_URL_WATCHLIST}`,
      },

      {
        id: "31",
        name: "Additional Settings",
        link: `${REACT_URL_ADDITIONAL_SETTINGS}`,
      },
      {
        id: "32",
        name: "NDA",
        link: `${REACT_URL_NDA}`,
      },
      {
        id: "33",
        name: "Video Upload",
        link: `${REACT_SAFETY_INSTRUCTIONS}`,
      },
      {
        id: "34",
        name: "Card Templates",
        link: `${REACT_URL_CARDTEMPLATE}`,
      },

      {
        id: "35",
        name: "SMS Templates",
        link: `${REACT_SMS_TEMPLATE}`,
      },

      {
        id: "36",
        name: "Access Control Integration",
        link: `${REACT_ATLAS_INTEGRATION}`,
      },

      {
        id: "37",
        name: "Integrations",
        link: `${REACT_INTEGRATION}`,
      },
      // {
      //   id: "38",
      //   name: "AD Management",
      //   link: `${REACT_ACTIVE_DIRECTORY}`,
      // },
    ],
  },
];

const dataEs = [
  {
    id: "0",
    name: "Tablero",
    link: `${REACT_URL_DASHBOARD}`,
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? vis_Dashboard_Icon
        : Dashboard_Icon,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? DashboardHover
        : Dashboard_Icon,
  },
  {
    id: "1",
    name: "Visitantes",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? visitor_icon
        : vis_visitor_icon,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? VisitorWhiteHover
        : vis_visitor_icon,
    items: [
      {
        id: "2",
        name: "Invitaciones",
        link: `${REACT_URL_VISITINVITE}`,
      },
      {
        id: "3",
        name:
          process.env.REACT_APP_ENVIRONMENT === "USA"
            ? "Registros Presenciales"
            : "Registros",
        link: `${REACT_URL_WALKINVISIT}`,
      },
      {
        id: "36",
        name: "Preinscripciones",
        link: `${REACT_PRE_REGISTRATION_LIST}`,
      },
      {
        id: "35",
        name: "Auto Registros",
        link: `${REACT_SELF_REGISTRATION_LIST}`,
      },

      {
        id: "4",
        name: "Aprobaciones",
        link: `${REACT_URL_APPROVAL}`,
      },
      {
        id: "5",
        name: "Listas de Bloqueo",
        link: `${REACT_URL_BLACKLISTVISITORS}`,
      },
    ],
  },
  {
    id: "6",
    name: "Empleados",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? Organization_Icon
        : vis_Organization_Icon,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? OrganizationHover
        : vis_Organization_Icon,
    items: [
      {
        id: "7",
        name: "Personas",
        link: `${REACT_URL_EMPLOYEE}`,
      },
      {
        id: "8",
        name: "Roles",
        link: `${REACT_URL_USERROLE}`,
      },
    ],
  },
  {
    id: "10",
    name: "Sitios",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? SiteManagement
        : vis_SiteManagement,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? SiteManagementHover
        : vis_SiteManagement,

    items: [
      {
        id: "11",
        name: "Tipos de Dirección",
        link: `${REACT_URL_ADDRESSTYPE}`,
      },
      {
        id: "12",
        name: "Tipos de Sitio",
        link: `${REACT_URL_SITETYPE}`,
      },
      {
        id: "13",
        name: "Todos los Sitios",
        link: `${REACT_URL_SITE}`,
      },
      {
        id: "14",
        name: "Horario de Verano (DST)",
        link: `${REACT_DAY_LIGHT_TIME}`,
      },
      {
        id: "15",
        name: "Zona",
        link: `${REACT_URL_ZONE}`,
      },
      {
        id: "16",
        name: "Franjas Horarias",
        link: `${REACT_TIME_SLOTS}`,
      },
      {
        id: "17",
        name: "Niveles de Acceso",
        link: `${REACT_ACCESSLEVELS_LIST}`,
      },
    ],
  },
  {
    id: "17",
    name: "Dispositivos",
    Icon: DeviceManagement,
    HoverIcon: DeviceManagementHover,
    items: [
      {
        id: "18",
        name: "Dispositivos",
        link: `${REACT_URL_DEVICELIST}`,
      },
    ],
  },
  {
    id: "34",
    name: "Emergencia",
    Icon: EmergencyMessageImg,
    HoverIcon: EmergencyMessageImgHover,
    items: [
      {
        id: "01",
        name: "Alertas",
        link: `${REACT_URL_EMERGENCYMESSAGE}`,
      },
    ],
  },

  {
    id: "19",
    name: "Informes",
    Icon: ReportIcon,
    HoverIcon: ReportIconHover,
    items: [
      {
        id: "20",
        name: "Informes Diarios",
        link: `${REACT_URL_DAILYREPORT}`,
      },
      {
        id: "21",
        name: "Invitaciones",
        link: `${REACT_URL_INVITATIONREPORT}`,
      },
      {
        id: "22",
        name: "Registros Presenciales",
        link: `${REACT_URL_WALKINREGISTRATIONREPORT}`,
      },
      {
        id: "23",
        name: "Auto Registros",
        link: `${REACT_URL_SELFREGISTRATIONREPORT}`,
      },
      {
        id: "24",
        name: "Preinscripciones",
        link: `${REACT_PRE_REGISTRATION_REPORT_LIST}`,
      },
      {
        id: "54",
        name: "Informes de Entregas",
        link: `${REACT_DELIVERY_REPORT}`,
      },
      {
        id: "55",
        name: "Comandos de Dispositivos",
        link: `${REACT_DEVICE_COMMANDS}`,
      },
      {
        id: "56",
        name: "Registros de Operaciones",
        link: `${REACT_OPERATION_LOGS}`,
      },
    ],
  },

  {
    id: "24",
    name: "Configuración",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? Device_Icon
        : vis_Device_Icon,
    HoverIcon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? settingHover
        : vis_Device_Icon,
    items: [
      {
        id: "25",
        name: "Tipos de Visitantes",
        link: `${REACT_URL_VISITORTYPE}`,
      },
      {
        id: "26",
        name: "Tipos de Propósito",
        link: `${REACT_URL_PURPOSETYPE_USA}`,
      },

      {
        id: "27",
        name: "Tipos de Listas de Bloqueo",
        link: `${REACT_URL_BLACKLISTTYPE}`,
      },

      {
        id: "28",
        name: "Listas de Verificación",
        link: `${REACT_URL_CHECKLISTTEMPLATE_USA}`,
      },

      {
        id: "29",
        name: "Listas de Vigilancia",
        link: `${REACT_URL_WATCHLIST}`,
      },

      {
        id: "31",
        name: "Configuraciones Adicionales",
        link: `${REACT_URL_ADDITIONAL_SETTINGS}`,
      },
      {
        id: "32",
        name: "NDA",
        link: `${REACT_URL_NDA}`,
      },
      {
        id: "33",
        name: "Video Upload",
        link: `${REACT_SAFETY_INSTRUCTIONS}`,
      },
      {
        id: "34",
        name: "Plantillas de Tarjetas",
        link: `${REACT_URL_CARDTEMPLATE}`,
      },

      {
        id: "35",
        name: "Plantillas de SMS",
        link: `${REACT_SMS_TEMPLATE}`,
      },

      {
        id: "36",
        name: "Integraciones Atlas",
        link: `${REACT_ATLAS_INTEGRATION}`,
      },

      {
        id: "37",
        name: "Integraciones",
        link: `${REACT_INTEGRATION}`,
      },
    ],
  },
];

const dataZh = [
  {
    id: "0",
    name: "仪表板",
    link: `${REACT_URL_DASHBOARD}`,
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? vis_Dashboard_Icon
        : Dashboard_Icon,
  },
  {
    id: "5",
    name: "游客",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? visitor_icon
        : vis_visitor_icon,
    items: [
      {
        id: "20",
        name: "邀请函",
        link: `${REACT_URL_INVITATIONS}`,
      },
      {
        id: "21",
        name: "注册",
        link: `${REACT_URL_REGISTRATIONS}`,
      },
      {
        id: "22",
        name: "批准",
        link: `${REACT_URL_APPROVAL}`,
      },
      {
        id: "23",
        name: "被阻止的访客",
        link: `${REACT_URL_BLOCKED_VISITORS}`,
      },
    ],
  },
  {
    id: "1",
    name: "组织",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? Organization_Icon
        : vis_Organization_Icon,
    items: [
      {
        id: "6",
        name: "人",
        link: `${REACT_URL_PERSON}`,
      },
      {
        id: "7",
        name: "角色",
        link: `${REACT_URL_ROLE}`,
      },
      {
        id: "8",
        name: "用户",
        link: `${REACT_URL_USER_LIST}`,
      },
    ],
  },
  {
    id: "2",
    name: "现场管理",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? SiteManagement
        : vis_SiteManagement,
    items: [
      {
        id: "10",
        name: "地址类型",
        link: `${REACT_URL_ADDRESSTYPE}`,
      },
      {
        id: "11",
        name: "网站类型",
        link: `${REACT_URL_SITETYPE}`,
      },
      {
        id: "12",
        name: "地点",
        link: `${REACT_URL_SITE}`,
      },
      {
        id: "13",
        name: "horario de verano",
        link: `${REACT_DAY_LIGHT_TIME}`,
      },
      {
        id: "14",
        name: "签入和签出设备",
        link: `${REACT_URL_CHECKINOUTDEVICES}`,
      },
    ],
  },
  {
    id: "3",
    name: "设置",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? Device_Icon
        : vis_Device_Icon,
    items: [
      {
        id: "13",
        name: "用途类型",
        link: `${REACT_URL_PURPOSETYPE}`,
      },
      {
        id: "14",
        name: "限制类型",
        link: `${REACT_URL_RESTRICTTYPE}`,
      },
      {
        id: "15",
        name: "清单",
        link: `${REACT_URL_CHECKLIST}`,
      },
      {
        id: "16",
        name: "关注列表",
        link: `${REACT_URL_WATCHLIST}`,
      },
    ],
  },
];

export default language === "en" ? dataEn : language === "es" ? dataEs : dataZh;
